import React from 'react'
import PropTypes from 'prop-types'
import { useStaticQuery, graphql } from "gatsby"
import { Container, Row, Col } from '../../../components/ui/wrapper'
import Heading from '../../../components/ui/heading'
import TeamMember from '../../../components/team-member'
import { TeamWrapper } from './team-area.style'

const TeamArea = ({ sectionStyle, headingStyle, headTeamStyle, headTeamRowStyle, teamStyle, executiveStyle }) => {
    const teamData = useStaticQuery(graphql`
        query {
            headTeamMember: allTeamsJson(filter: {position: {eq: "head"}}) {
                edges {
                    node {
                        id
                        name
                        designation
                        socials {
                            facebook
                            instagram
                            twitter
                        }
                        images {
                            large {
                                childImageSharp {
                                    fluid(maxWidth: 546, maxHeight: 672, quality: 100) {
                                        ...GatsbyImageSharpFluid_withWebp
                                        presentationWidth
                                        presentationHeight
                                    }
                                }
                            }
                        }
                    }
                }
            }
            executiveMember: allTeamsJson(filter: {position: {eq: "executive"}}) {
                edges {
                    node {
                        id
                        name
                        designation
                        socials {
                            facebook
                            instagram
                            twitter
                        }
                        images {
                            large {
                                childImageSharp {
                                    fluid(maxWidth: 546, maxHeight: 672, quality: 100) {
                                        ...GatsbyImageSharpFluid_withWebp
                                        presentationWidth
                                        presentationHeight
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    `)
    const headMembers = teamData.headTeamMember.edges;
    const executives = teamData.executiveMember.edges;
    return (
        <TeamWrapper>
            <Container>
                <Row>
                    <Col lg={12}>
                        <Heading {...headingStyle}>Evolve Advisors is made up of professional <br /> <span> consultants</span></Heading>
                    </Col>
                </Row>
                {/* <Row {...headTeamRowStyle}>
                    {headMembers && headMembers.map(headMember => (
                        <Col md={4} key={headMember.node.id}>
                            <TeamMember
                                {...teamStyle}
                                {...headTeamStyle}
                                imageSrc={headMember.node.images.large.childImageSharp}
                                name={headMember.node.name}
                                designation={headMember.node.designation}
                                social={headMember.node.socials}
                            />
                        </Col>
                    ))}
                </Row> */}
                <Row justify="center">
                    {executives && executives.map(executive => (
                        <Col lg={4} md={6} key={executive.node.id}>
                            <TeamMember
                                {...teamStyle}
                                {...executiveStyle}
                                imageSrc={executive.node.images.large && executive.node.images.large.childImageSharp}
                                name={executive.node.name}
                                designation={executive.node.designation}
                                social={executive.node.socials}
                            />
                        </Col>
                    ))}
                </Row>
            </Container>
        </TeamWrapper>
    )
}

TeamArea.propTypes = {
    sectionStyle: PropTypes.object,
    headingStyle: PropTypes.object
}

TeamArea.defaultProps = {
    headingStyle: {
        as: "h3",
        fontSize: "40px",
        lineHeight: 1.4,
        textalign: "center",
        mb: "85px",
        child: {
            color: "primary"
        },
        responsive: {
            large: {
                fontSize: "34px",
                mb: "70px"
            },
            medium: {
                fontSize: "28px",
                mb: "50px"
            }
        }
    },
    headTeamRowStyle: {
        mb: "36px",
        gutters: {
            lg: 60
        },
        responsive: {
            medium: {
                mb: "26px"
            },
            small: {
                mb: 0
            }
        }
    },
    teamStyle: {
        layout: 2,
        wrapperStyle: {
            mb: "30px"
        },
    },
    headTeamStyle: {
        infoStyle: {
            textalign: "center"
        }
    },
    executiveStyle: {
        infoStyle: {
            textalign: "center"
        },
        nameStyle: {
            fontSize: '18px',
            lineHeight: 1.78
        }
    }
}

export default TeamArea;